import { Injectable } from '@angular/core'
import { Router, UrlTree } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { ToastrService } from 'ngx-toastr'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private router: Router,
    private toaster: ToastrService,
    private translate: TranslateService
  ) {}
  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // The JWT is an HttpOnly cookie (not JS-readable). Use the stored non-sensitive user
    // object as the client-side "logged in" signal; the server still enforces auth and a
    // missing/expired cookie yields 401 (handled by the error interceptor).
    if (!localStorage.getItem('user')) {
      // this.toaster.error(this.translate.instant('Msg-Not-Authenticated'));
      this.router.navigate(['/login'])
      // this.router.navigate(['/']);
      return false
    } else {
      return true
    }
  }
}
